module.exports = __webpack_public_path__ + "static/media/cuboid2x2x5.5f652100.usdz";